<div class="container-visualizacao">
    <div class="row container-options">
        <div class="col-12">
            <button type="button" class="btn btn-primary mr-2" (click)="insert()"><i class="fas fa-plus" aria-hidden="true"></i> Nova</button>                 

            <!-- Opções -->
            <div class="btn-group" *ngIf="options?.hasAnyOption()">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-none d-sm-inline-block">Opções</span>
                </button>
                <div class="dropdown-menu">
                    <!-- Import ERP V1 -->
                    <a class="dropdown-item" *ngIf="options?.canImportErp_v1" (click)="importErp_v1()">
                        <i class="fas fa-download"></i> Importar do ERP
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="row container-table">
        <div class="col-12">
            <table class="table table-striped table-hover datatables" id="tableUnidadeNegocio">
                <thead>
                        <tr>
                            <th class="col-options"></th>
                            <th class="col-codigo text-right">Código</th>
                            <th class="col-codigo-integracao-erp text-right">Código ERP</th>
                            <th class="col-nome">Nome</th>
                            <th class="col-situacao text-center">Situação</th>
                        </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let entity of entities">
                        <td class="col-options">
                            <a (click)="edit(entity)"><i class="fas fa-pencil-alt" aria-hidden="true"></i></a>
                            <a (click)="delete(entity)"><i class="far fa-trash-alt" aria-hidden="true"></i></a>
                        </td>
                        <td class="col-codigo text-right">{{entity.codigo}}</td>
                        <td class="col-codigo-integracao-erp text-right">{{entity.codigoIntegracaoErp}}</td>
                        <td class="col-nome">{{entity.nome}}</td>
                        <td class="col-situacao text-center">
                            <span class="badge badge-success" *ngIf="entity.situacao === 1">Ativa</span>
                            <span class="badge badge-danger" *ngIf="entity.situacao === 2">Inativa</span>
                        </td>                         
                    </tr>
                </tbody>
            </table>                     
        </div>
    </div>    
</div>